import * as Yup from "yup"

export const getSignupSchema = (locale: string) => {
  const baseSchema = {
    name: Yup.string().required("required"),
    email: Yup.string().email("invalid").required("required"),
    password: Yup.string().min(6, "minchar").required("required"),
  }

  if (locale === "tr") {
    return Yup.object().shape({
      ...baseSchema,
      acceptTerms: Yup.boolean().oneOf([true], "required").required("required"),
      acceptDataProcessing: Yup.boolean()
        .oneOf([true], "required")
        .required("required"),
    })
  }

  return Yup.object().shape(baseSchema)
}

// For backwards compatibility
export const SignupSchema = Yup.object().shape({
  name: Yup.string().required("required"),
  email: Yup.string().email("invalid").required("required"),
  password: Yup.string().min(6, "minchar").required("required"),
})
